import React from 'react';
import ReactDOM from 'react-dom';

// css
import 'bootstrap/dist/css/bootstrap.min.css';

const rootEl = document.getElementById('root');

// Create a reusable render method that we can call more than once
let render = () => {
    // Dynamically import our main App component, and render it
    const MainApp = require('./App').default;
    ReactDOM.render(
        <MainApp/>,
        rootEl
    );
};

// console.log(module);

if (module.hot) {
    module.hot.accept('./App', () => {
        const NextApp = require('./App').default;
        render(
            <NextApp/>,
            rootEl
        );
    });
}

render();



// WEBPACK FOOTER //
// ./index.js